import React from 'react'
import styled from '@emotion/styled'
import { formatLondonTime } from 'components/Common/utils'

interface FormattedDateProps {
  children: number | Date | string
}

const FormattedDate = (props: FormattedDateProps) => (
  <OrderDatetime>
    {props.children ? (
      <>
        <p className='date'>{formatLondonTime(props.children, 'DD/MM/YYYY')}</p>
        <p className='time'>{formatLondonTime(props.children, 'hh:mm A')}</p>
      </>
    ) : (
      '--'
    )}
  </OrderDatetime>
)

const OrderDatetime = styled.div`
  > .date {
    color: #4a4a68;
    margin-bottom: 4px;
  }

  > .time {
    color: #8c8ca1;
    margin-bottom: 0;
  }
`

export default FormattedDate
